import { createAsyncThunk } from "@reduxjs/toolkit";
import { get, post, patch, del } from "../../Services/ApiBase";
import { API_ENDPOINTS } from "../../Services/ApiEndPoints";
import { getApiErrorMessage } from "../../utils/apiErrorMessage";

export const fetchRolesData = createAsyncThunk(
  "roles/fetchData",
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await get(API_ENDPOINTS.ROLES.GET_ALL);
      return response.data;
    } catch (error) {
      return rejectWithValue(getApiErrorMessage(error, "Failed to fetch roles data"));
    }
  },
  {
    condition: (params, { getState }) => {
      if (params?.force) return true;
      return getState().roles.data == null;
    },
  }
);

export const createRole = createAsyncThunk(
  "roles/create",
  async (roleData, { rejectWithValue }) => {
    try {
      const response = await post(API_ENDPOINTS.ROLES.CREATE, roleData, {}, "json", {
        suppressGlobalErrorModal: true,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(getApiErrorMessage(error, "Failed to create role"));
    }
  }
);

export const updateRole = createAsyncThunk(
  "roles/update",
  async ({ id, roleData }, { rejectWithValue }) => {
    try {
      const endpoint = API_ENDPOINTS.ROLES.UPDATE(id);
      const response = await patch(endpoint, roleData, {}, {}, { suppressGlobalErrorModal: true });
      return response.data;
    } catch (error) {
      return rejectWithValue(getApiErrorMessage(error, "Failed to update role"));
    }
  }
);

export const deleteRole = createAsyncThunk("roles/delete", async (id, { rejectWithValue }) => {
  try {
    const endpoint = API_ENDPOINTS.ROLES.DELETE(id);
    await del(endpoint);
    return id;
  } catch (error) {
    return rejectWithValue(getApiErrorMessage(error, "Failed to delete role"));
  }
});
